import {
  DEL_SHEET_FAIL,
  DEL_SHEET_REQ,
  DEL_SHEET_SUCCESS,
  GET_SHEET_SETTINGS_FAIL,
  GET_SHEET_SETTINGS_REQ,
  GET_SHEET_SETTINGS_SUCCESS,
  SAVE_SHEET_SETTINGS_FAIL,
  SAVE_SHEET_SETTINGS_REQ,
  SAVE_SHEET_SETTINGS_SUCCESS,
} from '../constants/settings';

export const sheetSettingsReducer = (
  state = { sheets: [], page: 1, totalPage: 0 },
  action
) => {
  switch (action.type) {
    case GET_SHEET_SETTINGS_REQ:
      return { loading: true };
    case GET_SHEET_SETTINGS_SUCCESS:
      return {
        loading: false,
        sheets: action.payload[0]?.data,
        page: action.payload[0]?.metadata[0]?.page || 1,
        totalPage:
          action.payload[0]?.metadata[0]?.total %
            action.payload[0]?.metadata[0]?.limit ===
          0
            ? action.payload[0]?.metadata[0]?.total /
              action.payload[0]?.metadata[0]?.limit
            : parseInt(
                action.payload[0]?.metadata[0]?.total /
                  action.payload[0]?.metadata[0]?.limit
              ) + 1,
      };
    case GET_SHEET_SETTINGS_FAIL:
      return { loading: false, error: action.payload };
    case SAVE_SHEET_SETTINGS_REQ:
      return { ...state, loading: true };
    case SAVE_SHEET_SETTINGS_SUCCESS:
      return {
        loading: false,
        success: true,
        sheets: [...state.sheets, action.payload].sort(function (a, b) {
          return new Date(b.createdAt) - new Date(a.createdAt);
        }),
      };
    case SAVE_SHEET_SETTINGS_FAIL:
      return { ...state, loading: false, error: action.payload };
    case DEL_SHEET_REQ:
      return { ...state, loading: true };
    case DEL_SHEET_SUCCESS:
      return {
        loading: false,
        successDelete: true,
        // sheets: state.sheets.filter((web) => web._id !== action.payload.id),
      };
    case DEL_SHEET_FAIL:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};
